import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getEventIcons(ctx, queryParams){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/event/v1/icon/get`, queryParams)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addEventIcon(ctx, queryParams){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/event/v1/icon/add`, queryParams.formData, {
                        headers:{
                            'Content-Type': 'multipart/form-data',
                            'dataType':'json'
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateEventIcon(ctx, queryParams){
            const id = queryParams.data.id

            return new Promise((resolve, reject) => {
                axios
                    .post(`/event/v1/icon/update/${id}`, queryParams.formData, {
                        headers:{
                            'Content-Type': 'multipart/form-data',
                            'dataType':'json'
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteEventIcon(ctx, id){
            return new Promise((resolve, reject) => {
              axios
                .delete(`/event/v1/icon/delete/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        getEvents(ctx, queryParams){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/event/v1/getEvents`, queryParams)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addEvent(ctx, queryParams){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/event/v1/addEvent`, queryParams.data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateEvent(ctx, queryParams){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/event/v1/update/${queryParams.data.id}`, queryParams.data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteEvent(ctx, id){
            return new Promise((resolve, reject) => {
              axios
                .delete(`/event/v1/delete/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        updateOrderingEvents(ctx, queryParams){
            const data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
                axios
                    .post('/event/v1/updateOrdering', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        getEventGallery(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post('/event/v1/gallery/getGallery', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addEventGallery(ctx, queryParams){
            const id  = queryParams.id

            return new Promise((resolve, reject) => {
                axios
                    .post(`/event/v1/gallery/add/${id}`, queryParams.formData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateOrdering(ctx, queryParams){
            const data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
                axios
                    .post('/event/v1/gallery/updateOrdering', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deteleEventGallery(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/event/v1/gallery/delete/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    }
}